import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import PageShell from '@/components/site/PageShell';
import PageHero from '@/components/site/PageHero';
import FAQSection from '@/components/site/FAQSection';

const COPY = {
  it: {
    eyebrow: 'FAQ',
    title_a: 'Le risposte chiare',
    title_b: 'per decidere con serenità.',
    subtitle:
      'Adozione del team, sicurezza dei dati, tempi di onboarding, ROI, FSE 2.0, pre-order 2027: 8 risposte chiare per decidere serenamente — senza chiamate inutili, senza commerciali insistenti.',
  },
  en: {
    eyebrow: 'FAQ',
    title_a: 'Clear answers',
    title_b: 'to decide with confidence.',
    subtitle:
      'Team adoption, data security, onboarding time, ROI, FSE 2.0, 2027 pre-order: 8 clear answers to decide with confidence — no useless calls, no pushy sales.',
  },
};

export const FaqPage = () => {
  const { locale } = useLanguage();
  const c = COPY[locale] || COPY.it;

  return (
    <PageShell title={c.eyebrow} testId="pv-faq-page">
      <PageHero
        eyebrow={c.eyebrow}
        title_a={c.title_a}
        title_b={c.title_b}
        subtitle={c.subtitle}
        ctas={['demo', 'whatsapp']}
        source="faq-hero"
        testId="pv-faq-page-hero"
      />
      <FAQSection compact />
    </PageShell>
  );
};

export default FaqPage;
